__webpack_require__.p = "/blog-platform/";